import React from 'react'

import { parseLocation } from '../../../common/utils/urlHelper'
import SeoHeadings from '../../components/seoHeadings/seoHeadings'

const ResultsInfo = ({ location, seoMeta, styles, TagName }) => {
  const parsedLocation = parseLocation(location)
  const shouldShowSubheading =
    (!parsedLocation.page ||
      (parsedLocation.page && parsedLocation.page === '1')) &&
    seoMeta.subHeading

  return (
    <SeoHeadings
      TagName={TagName}
      heading={seoMeta.heading}
      subHeading={shouldShowSubheading && seoMeta.subHeading}
      finePrint={seoMeta.finePrint}
      styles={styles}
    />
  )
}

export default ResultsInfo



// WEBPACK FOOTER //
// ./client/components/searchHeader/resultsInfo.js